// import { io, Socket } from "socket.io-client";

// let socket: Socket;

// export const getSocket = () => {
//   if (!socket) {
//     socket = io(); // same domain
//   }
//   return socket;
// };

// import { io, Socket } from "socket.io-client";

// let socket: Socket;

// export const getSocket = () => {
//   if (!socket) {
//     socket = io("http://localhost:8080", {
//       transports: ["websocket"], // optional
//       withCredentials: true, // if using cookies
//     });
//   }
//   return socket;
// };

// import { io, Socket } from "socket.io-client";

// let socket: Socket;

// export const getSocket = () => {
//   if (!socket) {
//     socket = io("http://localhost:8080", {
//       transports: ["websocket"], // optional
//       withCredentials: true, // if using cookies
//     });
//   }
//   return socket;
// };




// For Production
import { io, Socket } from "socket.io-client";

let socket: Socket;

export const getSocket = () => {
  if (!socket) {
    socket = io("https://www.toothsketch.com", {
      transports: ["websocket"],
      upgrade: false,
      withCredentials: true,
    });
  }

  return socket;
};